import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  Card,
  Typography,
  List,
  ListItem,
  IconButton,
  Drawer,
  useTheme,
} from "@mui/material";
import {
  useGetEmployeeScheduleDetailsByDateOnlyQuery,
  useGetPositionQuery,
  useGetTeamQuery,
  useDeleteRescheduleMutation,
  useGetRescheduleOrderByDateQuery,
} from "../../../Api/attoDeskApi";
import {
  IPosition,
  IScheduleListDetails,
  ITeam,
  ScheduleEdit,
} from "../../../Api/Interface/api.interface";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import { Privileges } from "../../../Core/Enum/enum";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import useUser from "../../../Core/hook/useUser";
import * as XLSX from "xlsx";
import TableViewIcon from "@mui/icons-material/TableView";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import jsPDF from "jspdf";
import "jspdf-autotable";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import NewPopUpTeam from "../../ScheduleList/Edit/scheduleEdit";
import NewPopUpTeamResche from "../../ScheduleList/Create/Reschedule";
import NewPopUpTeamRemove from "../../ScheduleList/Edit/RemovedEdited";
import NewPopUpTeamAdminEdit from "../../ScheduleList/Edit/index";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import RefreshIcon from "@mui/icons-material/Refresh";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useIsMobile from "../../../Core/hook/useIsMobile";
import { useSelector } from "react-redux";
import { RootState } from "../../../Store";
import CloseIcon from "@mui/icons-material/Close";

interface IDrawerPopUp {
  openModel?: boolean;
  handleCloseDialogPopUp: (close: boolean) => void;
  paymentMonthYearDate?: Dayjs;
}

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const capitalizeFirstLetter = (name: string) =>
  name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();

const DrawerPopUp = ({
  openModel = false,
  handleCloseDialogPopUp,
  paymentMonthYearDate,
}: IDrawerPopUp) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const isMobileRes = useIsMobile();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10000);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const { userHasRight } = useUser();
  const theme = useTheme();
  const [open] = React.useState(openModel);
  const handleClose = () => {
    handleCloseDialogPopUp(false);
  };
  console.log("open", openModel);
  const { companyLogo, logowidthPrint, companyName } = useSelector(
    (state: RootState) => state.company
  );

  const [selectedCoursing, setSelectedCoursing] =
    useState<IScheduleListDetails | null>(null);
  const [openDialog, setOpenDialog] = useState(false);

  const [selectedCoursingResche, setSelectedCoursingResche] =
    useState<IScheduleListDetails | null>(null);
  const [openDialogResche, setOpenDialogResche] = useState(false);

  const [selectedCoursingRemove, setSelectedCoursingRemove] =
    useState<IScheduleListDetails | null>(null);
  const [openDialogRemove, setOpenDialogRemove] = useState(false);

  const [selectedCoursingAdminEdit, setSelectedCoursingAdminEdit] =
    useState<ScheduleEdit | null>(null);
  const [openDialogAdminEdit, setOpenDialogAdminEdit] = useState(false);

  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<ScheduleEdit | null>(
    null
  );
  const [paymentMonthYear, setPaymentMonthYear] = useState<Dayjs>(dayjs());
  const [selectedDate, setSelectedDate] = React.useState<Dayjs | null>(dayjs());

  useEffect(() => {
    if (paymentMonthYearDate) {
      const parsedDate = dayjs(paymentMonthYearDate, "YYYY-MM-DD", true);
      if (parsedDate.isValid()) {
        setSelectedDate(parsedDate);
        setPaymentMonthYear(dayjs(parsedDate));
      }
    }
  }, [paymentMonthYearDate]);

  const { data, isLoading, isError, refetch } =
    useGetEmployeeScheduleDetailsByDateOnlyQuery({
      date: paymentMonthYear.format("YYYY-MM-DD"),
    });

  const handleIsBooked = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = event.target.value;
    setPaymentMonthYear(dayjs(selectedValue));
  };

  const { data: tenantData, isLoading: tenantIsLoading } = useGetTeamQuery({
    searchText: "",
    id: "",
  });

  const { data: positionData, isLoading: positionLoading } =
    useGetPositionQuery({
      searchText: "",
    });

  const {
    data: OrderData,
    isLoading: OrderDataIsLoadig,
    isError: OrderDataIsError,
  } = useGetRescheduleOrderByDateQuery({
    searchText: "",
    startDate: paymentMonthYear.format("YYYY-MM-DD"),
  });

  const teamList = useMemo(() => {
    return tenantData?.data as ITeam[];
  }, [tenantData?.data]);

  const positionList = useMemo(() => {
    return positionData?.data as IPosition[];
  }, [positionData?.data]);

  const postionMap = useMemo(() => {
    const map = new Map();
    positionList?.forEach((category) => {
      map.set(category.id, category.positionName);
    });
    return map;
  }, [positionList]);

  const teamMap = useMemo(() => {
    const map = new Map<
      number,
      {
        name: string;
        image: string;
        hourlySalary: string;
        otHourlySalary: string;
        positionName: string | null;
      }
    >();

    teamList?.forEach((teamMember) => {
      const fullName = `${capitalizeFirstLetter(
        teamMember.teamFirstName || ""
      )} ${capitalizeFirstLetter(teamMember.teamLastName || "")}`.trim();
      const positionName = postionMap.get(teamMember.teamPositionId) || null;

      map.set(teamMember.id, {
        name: fullName,
        image: teamMember.teamImg,
        hourlySalary: teamMember.teamHourlySalary,
        otHourlySalary: teamMember.teamOtHourlySalary,
        positionName,
      });
    });

    return map;
  }, [teamList, postionMap]);

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleDateChange = (newValue: Dayjs | null) => {
    setSelectedDate(newValue);

    if (newValue) {
      const mockEvent = {
        target: {
          value: newValue.format("YYYY-MM-DD"),
        },
      } as React.ChangeEvent<HTMLInputElement>;

      handleIsBooked(mockEvent);
    }
  };

  const goToPreviousDay = () => {
    const prevDay =
      selectedDate?.subtract(1, "day") || dayjs().subtract(1, "day");
    handleDateChange(prevDay);
  };

  const goToToday = () => {
    const today = dayjs();
    handleDateChange(today);
  };

  const goToNextDay = () => {
    const nextDay = selectedDate?.add(1, "day") || dayjs().add(1, "day");
    handleDateChange(nextDay);
  };

  const coursings: IScheduleListDetails[] = Array.isArray(data?.data)
    ? (data?.data as IScheduleListDetails[])
    : [];

  const coursingsTwo: ScheduleEdit[] = Array.isArray(OrderData?.data)
    ? (OrderData?.data as ScheduleEdit[])
    : [];

  const handleExportToExcel = () => {
    const exportData = coursings.map((row, index) => ({
      "#": index + 1,
      "Employee Name": teamMap.get(row.empid)?.name || "",
      Position: teamMap.get(row.empid)?.positionName || "",
      "Schedule ": `${formatTime(row.schedule?.startTime)} - ${formatTime(
        row.schedule?.endTime
      )}${row.schedule?.spansNextDay == true ? " [next day]" : ""} ${
        row.schedule && row.schedule.schedule_end_date
          ? row.schedule.status === "deleted"
            ? " [D]"
            : row.schedule.schedule_end_date &&
              row.schedule.status === "updated"
            ? " [Up]"
            : ""
          : ""
      }`,

      Status: row.isReSchedules ? "Modified" : "Usual",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ScheduleList");
    const paymentMonthYearPrint =
      dayjs(paymentMonthYear).format("YYYY MMM, DD");
    const fileName = `ScheduleList_${paymentMonthYearPrint}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };

  const handleExportToPDF = () => {
    const tableData = coursings.map((row, index) => [
      index + 1,
      teamMap.get(row.empid)?.name || "",
      teamMap.get(row.empid)?.positionName || "",
      formatTime(row.schedule?.startTime) +
        " - " +
        formatTime(row.schedule?.endTime) +
        (row.schedule?.spansNextDay ? " [next day]" : "") +
        (row.schedule && row.schedule.schedule_end_date
          ? row.schedule.status === "deleted"
            ? " [D]"
            : row.schedule.schedule_end_date &&
              row.schedule.status === "updated"
            ? " [Up]"
            : ""
          : ""),
      row.isReSchedules ? "Modified" : "Usual",
    ]);

    const tableHeaders = [
      ["#", "Employee Name", "Position", "Schedule ", "Status"],
    ];

    const currentMonth = dayjs().format("YYYY MMM, DD");

    const paymentMonthYearPrint =
      dayjs(paymentMonthYear).format("YYYY MMM, DD");

    const doc = new jsPDF("l", "mm", "a4");

    const imageUrl = companyLogo;
    const pageWidth = doc.internal.pageSize.width;
    const imgWidth = logowidthPrint;
    const imgHeight = 10;
    // const imgX = (pageWidth - imgWidth) / 2;
    const imgY = 10;
    const imgX = 15;

    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      doc.addImage(img, "PNG", imgX, imgY, imgWidth, imgHeight);

      const textStartY = imgY + imgHeight / 2;

      const centerText = (text: string, y: number) => {
        const textWidth = doc.getTextWidth(text);
        const textX = (pageWidth - textWidth) / 2;
        doc.text(text, textX, y);
      };

      const rightAlignText = (text: string, y: number) => {
        doc.setFontSize(10);
        const textWidth = doc.getTextWidth(text);
        const textX = pageWidth - textWidth - 15;
        doc.text(text, textX, y);
      };

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(`Schedule List`, textStartY);

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(`Date: ${paymentMonthYearPrint}`, textStartY + 5);

      (doc as any).autoTable({
        head: tableHeaders,
        body: tableData,
        startY: textStartY + 15,
        theme: "grid",
        styles: { fontSize: 8 },
        headStyles: { fillColor: [200, 200, 200] },
        alternateRowStyles: { fillColor: [245, 245, 245] },
      });

      const fileName = `ScheduleList_${paymentMonthYearPrint}.pdf`;

      doc.save(fileName);
    };
  };

  const handleOpenDeletePopup = (coursingsTwo: ScheduleEdit) => {
    setCoursingToDelete(coursingsTwo);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const [deleteCategory] = useDeleteRescheduleMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the schedule");
    }
  };

  const handleOpenDialog = (coursing: IScheduleListDetails) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
    refetch();
  };

  const handleOpenDialogResche = (coursing: IScheduleListDetails) => {
    setSelectedCoursingResche(coursing);
    setOpenDialogResche(true);
  };

  const handleCloseDialogResche = () => {
    setSelectedCoursingResche(null);
    setOpenDialogResche(false);
    refetch();
  };

  const handleOpenDialogRemove = (coursing: IScheduleListDetails) => {
    setSelectedCoursingRemove(coursing);
    setOpenDialogRemove(true);
  };

  const handleCloseDialogRemove = () => {
    setSelectedCoursingRemove(null);
    setOpenDialogRemove(false);
    refetch();
  };

  const handleOpenDialogAdminEdit = (coursingsTwo: ScheduleEdit) => {
    setSelectedCoursingAdminEdit(coursingsTwo);
    setOpenDialogAdminEdit(true);
  };

  const handleCloseDialogAdminEdit = () => {
    setSelectedCoursingAdminEdit(null);
    setOpenDialogAdminEdit(false);
    refetch();
  };

  const handleAddProductClick = () => {
    // navigate("/re-Schedule/create");
    navigate(
      `/re-Schedule/create?date=${paymentMonthYear.format("YYYY-MM-DD")}`
    );
  };
  const handleAddReschedule = () => {
    navigate(`/re-Schedule/list`);
  };

  const handleAddweeklyReport = () => {
    navigate(`/attendance/weekly/report`);
  };

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          // width: isMobileRes ? "100vw" : 600,
          // maxWidth: "100vw",
          backgroundColor: theme.palette.background.default,
          padding: isMobileRes ? 1 : 2,
        },
      }}
    >
      <Grid container spacing={3}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.card}>
            {isMobileRes ? (
              <Grid
                container
                justifyContent={"space-between"}
                spacing={2}
                sx={{ borderBottom: 2, padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    variant="contained"
                    className={classes.editButton}
                    onClick={handleClose}
                  >
                    <CloseIcon />
                  </Button>
                </Grid>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-start" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-start"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      alignContent: "center",
                    }}
                  >
                    <Grid item>
                      <Typography className={classes.cardTitle}>
                        Schedule List
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container spacing={1}>
                    <Grid
                      item
                      sx={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      <List className={classes.ListPayroll}>
                        <ListItem className={classes.ListItemPayroll}>
                          <IconButton
                            color="primary"
                            onClick={goToPreviousDay}
                            aria-label="Previous Day"
                          >
                            <KeyboardArrowLeftIcon />
                          </IconButton>
                        </ListItem>
                        <ListItem className={classes.ListItemPayroll}>
                          <Button
                            className={classes.ListItemPayrollToday}
                            // onClick={goToToday}
                            // aria-label="Today"
                          >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                value={selectedDate}
                                onChange={handleDateChange}
                                slotProps={{
                                  textField: {
                                    placeholder: "Date of Birth",
                                    size: "small",
                                    sx: {
                                      width: "140px",
                                    },
                                    InputProps: {
                                      sx: {
                                        fontSize: 14,
                                        color: "#97c3df",
                                      },
                                      // classes: {
                                      //   // root: classes.textFieldQuote,
                                      // },
                                      classes: {
                                        root: classes.formControlListStatus,
                                        notchedOutline: classes.notchedOutline,
                                      },
                                    },
                                    InputLabelProps: {
                                      sx: {
                                        fontSize: 14,
                                        color: "#97c3df",
                                      },
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </Button>
                        </ListItem>
                        <ListItem className={classes.ListItemPayroll}>
                          <IconButton
                            color="primary"
                            onClick={goToNextDay}
                            aria-label="Previous Day"
                          >
                            <KeyboardArrowRightIcon />
                          </IconButton>
                        </ListItem>
                      </List>
                    </Grid>
                    <Grid item>
                      <Button
                        startIcon={<TableViewIcon />}
                        className={classes.addButtonPdfExcel}
                        onClick={handleExportToExcel}
                      >
                        Excel
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        startIcon={<LocalPrintshopSharpIcon />}
                        className={classes.addButtonPdfExcel}
                        onClick={handleExportToPDF}
                      >
                        pdf
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-end"
                    sx={{
                      display: "flex",
                      justifyContent: {
                        xs: "flex-end",
                        md: "flex-end",
                      },
                    }}
                  >
                    <Grid item>
                      <Link
                        to={`/attendance/weekly/report`}
                        className={classes.iconLinkPropNormal}
                      >
                        <Button
                          // variant="contained"
                          className={classes.addNewButton}
                          onClick={handleAddweeklyReport}
                        >
                          Weekly Report
                        </Button>
                      </Link>
                    </Grid>
                    <Grid item>
                      <Link
                        to={`/re-Schedule/create?date=${paymentMonthYear.format(
                          "YYYY-MM-DD"
                        )}`}
                        className={classes.iconLinkPropNormal}
                      >
                        <Button
                          // variant="contained"
                          className={classes.addNewButton}
                          onClick={handleAddProductClick}
                        >
                          Add New
                        </Button>
                      </Link>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ borderBottom: 2, padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    variant="contained"
                    className={classes.editButton}
                    onClick={handleClose}
                  >
                    <CloseIcon />
                  </Button>
                </Grid>
                <Grid
                  item
                  lg={4}
                  md={4}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-start" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-start"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      alignContent: "center",
                    }}
                  >
                    <Grid item>
                      <Typography className={classes.cardTitle}>
                        Schedule List
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={8}
                  md={8}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-end"
                    sx={{
                      display: "flex",
                      justifyContent: {
                        xs: "flex-start",
                        md: "flex-end",
                      },
                    }}
                  >
                    <Grid
                      item
                      sx={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      <List className={classes.ListPayroll}>
                        <ListItem className={classes.ListItemPayroll}>
                          <IconButton
                            color="primary"
                            onClick={goToPreviousDay}
                            aria-label="Previous Day"
                          >
                            <KeyboardArrowLeftIcon />
                          </IconButton>
                        </ListItem>
                        <ListItem className={classes.ListItemPayroll}>
                          <Button
                            className={classes.ListItemPayrollToday}
                            // onClick={goToToday}
                            // aria-label="Today"
                          >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                value={selectedDate}
                                onChange={handleDateChange}
                                slotProps={{
                                  textField: {
                                    placeholder: "Date of Birth",
                                    size: "small",
                                    sx: {
                                      width: "140px",
                                    },
                                    InputProps: {
                                      sx: {
                                        fontSize: 14,
                                        color: "#97c3df",
                                      },
                                      // classes: {
                                      //   // root: classes.textFieldQuote,
                                      // },
                                      classes: {
                                        root: classes.formControlListStatus,
                                        notchedOutline: classes.notchedOutline,
                                      },
                                    },
                                    InputLabelProps: {
                                      sx: {
                                        fontSize: 14,
                                        color: "#97c3df",
                                      },
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </Button>
                        </ListItem>
                        <ListItem className={classes.ListItemPayroll}>
                          <IconButton
                            color="primary"
                            onClick={goToNextDay}
                            aria-label="Previous Day"
                          >
                            <KeyboardArrowRightIcon />
                          </IconButton>
                        </ListItem>
                      </List>
                    </Grid>
                    <Grid item>
                      <Button
                        startIcon={<TableViewIcon />}
                        className={classes.addButtonPdfExcel}
                        onClick={handleExportToExcel}
                      >
                        Excel
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        startIcon={<LocalPrintshopSharpIcon />}
                        className={classes.addButtonPdfExcel}
                        onClick={handleExportToPDF}
                      >
                        pdf
                      </Button>
                    </Grid>

                    <Grid item>
                      <Link
                        to={`/attendance/weekly/report`}
                        className={classes.iconLinkPropNormal}
                      >
                        <Button
                          // variant="contained"
                          className={classes.addNewButton}
                          onClick={handleAddweeklyReport}
                        >
                          Weekly Report
                        </Button>
                      </Link>
                    </Grid>
                    <Grid item>
                      <Link
                        to={`/re-Schedule/create?date=${paymentMonthYear.format(
                          "YYYY-MM-DD"
                        )}`}
                        className={classes.iconLinkPropNormal}
                      >
                        <Button
                          // variant="contained"
                          className={classes.addNewButton}
                          onClick={handleAddProductClick}
                        >
                          Add New
                        </Button>
                      </Link>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}

            <Grid>
              <TableContainer>
                <Table className={classes.table}>
                  <TableHead className={classes.tableHeaderRow}>
                    <TableRow>
                      <TableCell className={classes.tablheader}>
                        <strong>Name</strong>
                      </TableCell>
                      {!isMobileRes && (
                        <TableCell
                          className={classes.tablheader}
                          // sx={{ textAlign: "center" }}
                        >
                          <strong>Position</strong>
                        </TableCell>
                      )}
                      <TableCell
                        className={classes.tablheader}
                        // sx={{ textAlign: "center" }}
                      >
                        <strong>Schedule </strong>
                      </TableCell>
                      <TableCell
                        className={classes.tablheader}
                        // sx={{ textAlign: "center" }}
                      >
                        <strong>Status</strong>
                      </TableCell>
                      {userHasRight(Privileges.ScheduleEdit) && (
                        // <TableCell className={classes.tablheader}>
                        //   <Grid
                        //     container
                        //     spacing={1}
                        //     // sx={{ display: "flex", justifyContent: "flex-end" }}
                        //   >
                        //     <Grid
                        //       item
                        //       lg={4}
                        //       md={6}
                        //       textAlign={"center"}
                        //       alignContent={"center"}
                        //     >
                        //       <strong>Remove</strong>
                        //     </Grid>
                        //     <Grid
                        //       item
                        //       lg={4}
                        //       md={6}
                        //       textAlign={"center"}
                        //       alignContent={"center"}
                        //     >
                        //       <strong>Reschedule</strong>
                        //     </Grid>
                        //     <Grid
                        //       item
                        //       lg={4}
                        //       md={6}
                        //       textAlign={"center"}
                        //       alignContent={"center"}
                        //     >
                        //       <strong>Edit</strong>
                        //     </Grid>
                        //   </Grid>
                        // </TableCell>
                        <TableCell
                          className={classes.tablheader}
                          sx={{ textAlign: "right" }}
                        >
                          <strong>Actions</strong>
                        </TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {isLoading || positionLoading || tenantIsLoading ? (
                      <TableRow>
                        <TableCell colSpan={20} align="center">
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="10vh"
                          >
                            <CircularProgress />
                          </Box>
                        </TableCell>
                      </TableRow>
                    ) : isError || coursings.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={20} align="center">
                          {isError
                            ? "Error fetching data"
                            : "No data available"}
                        </TableCell>
                      </TableRow>
                    ) : (
                      coursings
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row: IScheduleListDetails, index) => (
                          <TableRow
                            key={index}
                            className={classes.tableRowHover}
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              className={classes.tablCell}
                            >
                              {" "}
                              <Grid container spacing={1}>
                                {/* <Grid
                                item
                                textAlign={"center"}
                                alignContent={"center"}
                              >
                                <CustomCheckbox name="checkbox" />
                              </Grid> */}
                                {/* <Grid item>
                                <Box className={classes.SelectImageTableBox}>
                                  {teamMap.get(row.empid)?.image ? (
                                    <img
                                      src={teamMap.get(row.empid)?.image}
                                      alt="Category Image"
                                      className={classes.SelectImageTable}
                                    />
                                  ) : (
                                    <Avatar
                                      alt="Travis Howard"
                                      src={AvatarImg}
                                      className={classes.SelectImageTable}
                                    />
                                  )}
                                </Box>
                              </Grid> */}
                                <Grid item>
                                  <Link
                                    to={`/team-history/${row.empid}`}
                                    className={classes.iconLinkPropNormal}
                                  >
                                    <Typography
                                      className={classes.nameTableList}
                                    >
                                      {teamMap.get(row.empid)?.name || ""}
                                      {/* <span
                                      style={{
                                        cursor: "pointer",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      <FontAwesomeIcon
                                        icon={faUser}
                                        style={{ color: "#1976d2" }}
                                      />
                                    </span> */}
                                    </Typography>
                                  </Link>
                                </Grid>
                              </Grid>
                            </TableCell>
                            {!isMobileRes && (
                              <TableCell
                                scope="row"
                                className={classes.tablCell}
                                // sx={{ textAlign: "center" }}
                              >
                                {teamMap.get(row.empid)?.positionName}
                              </TableCell>
                            )}
                            <TableCell
                              scope="row"
                              className={classes.tablCell}
                              // sx={{ textAlign: "center" }}
                            >
                              {formatTime(row.schedule?.startTime)} -{" "}
                              {formatTime(row.schedule?.endTime)}{" "}
                              {row.schedule &&
                                row.schedule.spansNextDay == true && (
                                  <span
                                    style={{
                                      color: "#e3791a",
                                      fontWeight: 600,
                                      lineHeight: 1.5,
                                      fontSize: "0.875rem",
                                      paddingLeft: "1px",
                                    }}
                                  >
                                    [next day]
                                  </span>
                                )}
                              {row.schedule &&
                              row.schedule.schedule_end_date ? (
                                row.schedule.status === "deleted" ? (
                                  <span
                                    style={{
                                      color: "#d32f2f", // red
                                      fontWeight: 600,
                                      paddingLeft: "1px",
                                    }}
                                  >
                                    [D]
                                  </span>
                                ) : row.schedule.schedule_end_date &&
                                  row.schedule.status === "updated" ? (
                                  <span
                                    style={{
                                      color: "#1976d2", // blue
                                      fontWeight: 600,
                                      paddingLeft: "1px",
                                    }}
                                  >
                                    [Up]
                                  </span>
                                ) : null
                              ) : null}
                            </TableCell>
                            <TableCell
                              scope="row"
                              className={classes.tablCell}
                              // sx={{ textAlign: "center" }}
                            >
                              <Grid
                                container
                                spacing={1}
                                // justifyContent={"center"}
                              >
                                <Grid
                                  item
                                  lg={12}
                                  md={12}
                                  sm={12}
                                  xs={12}
                                  sx={{
                                    display: "flex",
                                    // justifyContent: "center",
                                  }}
                                >
                                  <Box
                                    className={
                                      row.isReSchedules === false
                                        ? classes.editButtonStatusWaiting
                                        : classes.editButtonStatusAvailable
                                    }
                                  >
                                    {row.isReSchedules ? "Modified" : "Usual"}
                                  </Box>
                                </Grid>
                              </Grid>
                            </TableCell>
                            {userHasRight(Privileges.ScheduleEdit) && (
                              // <TableCell scope="row" className={classes.tablCell}>
                              //   <Grid
                              //     container
                              //     spacing={1}
                              //     // sx={{ display: "flex", justifyContent: "flex-end" }}
                              //   >
                              //     <Grid
                              //       item
                              //       lg={4}
                              //       md={6}
                              //       textAlign={"center"}
                              //       alignContent={"center"}
                              //     >
                              //       <Button
                              //         // variant="contained"
                              //         className={classes.actionButton}
                              //         onClick={() => handleOpenDialogRemove(row)}
                              //       >
                              //         Remove
                              //       </Button>
                              //     </Grid>
                              //     <Grid
                              //       item
                              //       lg={4}
                              //       md={6}
                              //       textAlign={"center"}
                              //       alignContent={"center"}
                              //     >
                              //       <Button
                              //         // variant="contained"
                              //         className={classes.actionButton}
                              //         onClick={() => handleOpenDialogResche(row)}
                              //       >
                              //         Reschedule
                              //       </Button>
                              //     </Grid>
                              //     <Grid
                              //       item
                              //       lg={4}
                              //       md={6}
                              //       textAlign={"center"}
                              //       alignContent={"center"}
                              //     >
                              //       <Button
                              //         // variant="contained"
                              //         className={classes.actionButton}
                              //         onClick={() => handleOpenDialog(row)}
                              //       >
                              //         Edit
                              //       </Button>
                              //     </Grid>
                              //   </Grid>
                              // </TableCell>

                              <TableCell
                                scope="row"
                                className={classes.tablCell}
                              >
                                {row.schedule &&
                                row.schedule.schedule_end_date == null ? (
                                  <Grid
                                    container
                                    spacing={1}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    <Grid item>
                                      <Button
                                        // variant="contained"
                                        className={classes.viewButtonList}
                                        onClick={() =>
                                          handleOpenDialogResche(row)
                                        }
                                      >
                                        <RefreshIcon
                                          className={classes.viewListIcon}
                                        />
                                      </Button>
                                    </Grid>
                                    <Grid item>
                                      <Button
                                        // variant="contained"
                                        className={classes.editButtonList}
                                        onClick={() => handleOpenDialog(row)}
                                      >
                                        <EditSharpIcon
                                          className={classes.editListIcon}
                                        />
                                      </Button>
                                    </Grid>
                                    <Grid item>
                                      <Button
                                        // variant="contained"
                                        className={classes.deleteButtonList}
                                        onClick={() =>
                                          handleOpenDialogRemove(row)
                                        }
                                      >
                                        <DeleteOutlineSharpIcon
                                          className={classes.deleteListIcon}
                                        />
                                      </Button>
                                    </Grid>
                                  </Grid>
                                ) : (
                                  <Typography
                                    textAlign="right"
                                    sx={{
                                      color:
                                        row.schedule?.status === "deleted"
                                          ? "#d32f2f"
                                          : row.schedule?.status === "updated"
                                          ? "#1976d2"
                                          : "#000",
                                      fontWeight: 600,
                                      lineHeight: 1.5,
                                      fontSize: "0.875rem",
                                      paddingLeft: "1px",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    {row.schedule?.schedule_end_date && (
                                      <>
                                        -- Previous time slot{" "}
                                        {row.schedule.status === "deleted"
                                          ? "(deleted on "
                                          : row.schedule.status === "updated"
                                          ? "(updated on "
                                          : "("}
                                        {dayjs(
                                          row.schedule.schedule_end_date
                                        ).format("MMM D, YYYY h:mm A")}
                                        {")"} --
                                      </>
                                    )}
                                  </Typography>
                                )}
                              </TableCell>
                            )}
                          </TableRow>
                        ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {selectedCoursing && (
                <NewPopUpTeam
                  openModel={openDialog}
                  handleCloseDialog={handleCloseDialog}
                  data={selectedCoursing}
                  scheduleDate={paymentMonthYear.format("YYYY-MM-DD")}
                />
              )}
              {selectedCoursingRemove && (
                <NewPopUpTeamRemove
                  openModel={openDialogRemove}
                  handleCloseDialog={handleCloseDialogRemove}
                  data={selectedCoursingRemove}
                  scheduleDate={paymentMonthYear.format("YYYY-MM-DD")}
                />
              )}
              {selectedCoursingResche && (
                <NewPopUpTeamResche
                  openModel={openDialogResche}
                  handleCloseDialog={handleCloseDialogResche}
                  data={selectedCoursingResche}
                  scheduleDate={paymentMonthYear.format("YYYY-MM-DD")}
                />
              )}
            </Grid>
          </Card>
        </Grid>

        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.card}>
            {isMobileRes ? (
              <Grid
                container
                justifyContent={"space-between"}
                spacing={2}
                sx={{ borderBottom: 2, padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  pt={2}
                  alignContent={"center"}
                  justifyContent="flex-start"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    alignContent: "center",
                  }}
                >
                  <Typography className={classes.cardTitle}>
                    Reschedule List
                  </Typography>
                </Grid>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-end"
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Grid item>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          value={selectedDate}
                          onChange={handleDateChange}
                          className={classes.searchTextField}
                          slotProps={{
                            textField: {
                              placeholder: "Start Date",
                              size: "small",
                              sx: {
                                width: "140px",
                              },
                              InputProps: {
                                sx: {
                                  fontSize: 14,
                                },
                                // classes: {
                                //   root: classes.textFieldQuote,
                                //   notchedOutline: classes.notchedOutline,
                                // },
                                classes: {
                                  root: classes.formControlListStatus,
                                },
                              },
                              InputLabelProps: {
                                sx: {
                                  fontSize: 14,
                                },
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item>
                      <Link
                        to={`/re-Schedule/list`}
                        className={classes.iconLinkPropNormal}
                      >
                        <Button
                          // variant="contained"
                          className={classes.addNewButton}
                          onClick={handleAddReschedule}
                        >
                          Reschedule
                        </Button>
                      </Link>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ borderBottom: 2, padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={4}
                  md={4}
                  sm={12}
                  xs={12}
                  pt={2}
                  alignContent={"center"}
                  justifyContent="flex-start"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    alignContent: "center",
                  }}
                >
                  <Typography className={classes.cardTitle}>
                    Reschedule List
                  </Typography>
                </Grid>
                <Grid
                  item
                  lg={8}
                  md={8}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-end"
                    sx={{
                      display: "flex",
                      justifyContent: {
                        xs: "flex-start",
                        md: "flex-end",
                      },
                    }}
                  >
                    <Grid item>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          value={selectedDate}
                          onChange={handleDateChange}
                          className={classes.searchTextField}
                          slotProps={{
                            textField: {
                              placeholder: "Start Date",
                              size: "small",
                              sx: {
                                width: "140px",
                              },
                              InputProps: {
                                sx: {
                                  fontSize: 14,
                                },
                                // classes: {
                                //   root: classes.textFieldQuote,
                                //   notchedOutline: classes.notchedOutline,
                                // },
                                classes: {
                                  root: classes.formControlListStatus,
                                },
                              },
                              InputLabelProps: {
                                sx: {
                                  fontSize: 14,
                                },
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item>
                      <Link
                        to={`/re-Schedule/list`}
                        className={classes.iconLinkPropNormal}
                      >
                        <Button
                          // variant="contained"
                          className={classes.addNewButton}
                          onClick={handleAddReschedule}
                        >
                          Reschedule
                        </Button>
                      </Link>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}
            <Grid>
              <TableContainer>
                <Table className={classes.table}>
                  <TableHead className={classes.tableHeaderRow}>
                    <TableRow>
                      <TableCell className={classes.tablheader}>
                        <strong>Name</strong>
                      </TableCell>
                      {!isMobileRes && (
                        <TableCell
                          className={classes.tablheader}
                          // sx={{ textAlign: "center" }}
                        >
                          <strong>Position</strong>
                        </TableCell>
                      )}
                      <TableCell
                        className={classes.tablheader}
                        // sx={{ textAlign: "center" }}
                      >
                        <strong>Schedule </strong>
                      </TableCell>
                      <TableCell
                        className={classes.tablheader}
                        // sx={{ textAlign: "center" }}
                      >
                        <strong>Modified</strong>
                      </TableCell>
                      {userHasRight(Privileges.ScheduleEdit) && (
                        <TableCell
                          className={classes.tablheader}
                          sx={{ textAlign: "right" }}
                        >
                          <strong>Actions</strong>
                        </TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {OrderDataIsLoadig || positionLoading || tenantIsLoading ? (
                      <TableRow>
                        <TableCell colSpan={20} align="center">
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="10vh"
                          >
                            <CircularProgress />
                          </Box>
                        </TableCell>
                      </TableRow>
                    ) : OrderDataIsError || coursingsTwo.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={20} align="center">
                          {OrderDataIsError
                            ? "Error fetching data"
                            : "No data available"}
                        </TableCell>
                      </TableRow>
                    ) : (
                      coursingsTwo
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row: ScheduleEdit, index) => (
                          <TableRow
                            key={index}
                            className={classes.tableRowHover}
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              className={classes.tablCell}
                            >
                              {" "}
                              <Grid container spacing={1}>
                                {/* <Grid
                                item
                                textAlign={"center"}
                                alignContent={"center"}
                              >
                                <CustomCheckbox name="checkbox" />
                              </Grid> */}
                                {/* <Grid item>
                                <Box className={classes.SelectImageTableBox}>
                                  {teamMap.get(row.empid)?.image ? (
                                    <img
                                      src={teamMap.get(row.empid)?.image}
                                      alt="Category Image"
                                      className={classes.SelectImageTable}
                                    />
                                  ) : (
                                    <Avatar
                                      alt="Travis Howard"
                                      src={AvatarImg}
                                      className={classes.SelectImageTable}
                                    />
                                  )}
                                </Box>
                              </Grid> */}
                                <Grid item>
                                  <Link
                                    to={`/team-history/${row.empid}`}
                                    className={classes.iconLinkPropNormal}
                                  >
                                    <Typography
                                      className={classes.nameTableList}
                                    >
                                      {teamMap.get(row.empid)?.name || ""}
                                      {/* <span
                                      style={{
                                        cursor: "pointer",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      <FontAwesomeIcon
                                        icon={faUser}
                                        style={{ color: "#1976d2" }}
                                      />
                                    </span> */}
                                    </Typography>
                                  </Link>
                                </Grid>
                              </Grid>
                            </TableCell>
                            {!isMobileRes && (
                              <TableCell
                                scope="row"
                                className={classes.tablCell}
                                // sx={{ textAlign: "center" }}
                              >
                                {teamMap.get(row.empid)?.positionName}
                              </TableCell>
                            )}
                            <TableCell
                              scope="row"
                              className={classes.tablCell}
                              // sx={{ textAlign: "center" }}
                            >
                              {formatTime(row.startTime)} -{" "}
                              {formatTime(row.endTime)}
                              {row.spansNextDay == true && (
                                <span
                                  style={{
                                    color: "#e3791a",
                                    fontWeight: 600,
                                    lineHeight: 1.5,
                                    fontSize: "0.875rem",
                                    paddingLeft: "1px",
                                  }}
                                >
                                  [next day]
                                </span>
                              )}
                            </TableCell>
                            <TableCell
                              scope="row"
                              className={classes.tablCell}
                              // sx={{ textAlign: "center" }}
                            >
                              <Typography>{`${row.created_by}`}</Typography>
                              <Typography>
                                {"( "}
                                {dayjs(row.created_at).format(
                                  "YYYY-MM-DD hh:mm A"
                                )}
                                {" )"}
                              </Typography>
                            </TableCell>
                            {userHasRight(Privileges.ScheduleEdit) && (
                              // <TableCell scope="row" className={classes.tablCell}>
                              //   <Grid
                              //     container
                              //     spacing={1}
                              //     // sx={{ display: "flex", justifyContent: "flex-end" }}
                              //   >
                              //     <Grid
                              //       item
                              //       lg={4}
                              //       md={6}
                              //       textAlign={"center"}
                              //       alignContent={"center"}
                              //     >
                              //       <Button
                              //         // variant="contained"
                              //         className={classes.actionButton}
                              //         onClick={() => handleOpenDialogRemove(row)}
                              //       >
                              //         Remove
                              //       </Button>
                              //     </Grid>
                              //     <Grid
                              //       item
                              //       lg={4}
                              //       md={6}
                              //       textAlign={"center"}
                              //       alignContent={"center"}
                              //     >
                              //       <Button
                              //         // variant="contained"
                              //         className={classes.actionButton}
                              //         onClick={() => handleOpenDialogResche(row)}
                              //       >
                              //         Reschedule
                              //       </Button>
                              //     </Grid>
                              //     <Grid
                              //       item
                              //       lg={4}
                              //       md={6}
                              //       textAlign={"center"}
                              //       alignContent={"center"}
                              //     >
                              //       <Button
                              //         // variant="contained"
                              //         className={classes.actionButton}
                              //         onClick={() => handleOpenDialog(row)}
                              //       >
                              //         Edit
                              //       </Button>
                              //     </Grid>
                              //   </Grid>
                              // </TableCell>

                              <TableCell
                                scope="row"
                                className={classes.tablCell}
                              >
                                <Grid
                                  container
                                  spacing={1}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <Grid item>
                                    <Button
                                      // variant="contained"
                                      className={classes.editButtonList}
                                      onClick={() =>
                                        handleOpenDialogAdminEdit(row)
                                      }
                                    >
                                      <EditSharpIcon
                                        className={classes.editListIcon}
                                      />
                                    </Button>
                                  </Grid>
                                  <Grid item>
                                    <Button
                                      // variant="contained"
                                      className={classes.deleteButtonList}
                                      onClick={() => handleOpenDeletePopup(row)}
                                    >
                                      <DeleteOutlineSharpIcon
                                        className={classes.deleteListIcon}
                                      />
                                    </Button>
                                  </Grid>
                                </Grid>
                              </TableCell>
                            )}
                          </TableRow>
                        ))
                    )}
                  </TableBody>
                </Table>
                {/* <Grid
                spacing={5}
                p={"18px"}
                py={4}
                justifyContent={"end"}
                container
                textAlign={"center"}
                alignContent={"center"}
                alignItems={"center"}
              >
                <Grid
                  sx={{
                    textAlign: "end",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                  }}
                >
                  <Pagination
                    count={coursings.length}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    onPageChange={handleChangePage}
                  />
                </Grid>
              </Grid> */}
              </TableContainer>

              {selectedCoursingAdminEdit && (
                <NewPopUpTeamAdminEdit
                  openModel={openDialogAdminEdit}
                  handleCloseDialog={handleCloseDialogAdminEdit}
                  data={selectedCoursingAdminEdit}
                />
              )}
              {selectedCoursing && (
                <NewPopUpTeam
                  openModel={openDialog}
                  handleCloseDialog={handleCloseDialog}
                  data={selectedCoursing}
                  scheduleDate={paymentMonthYear.format("YYYY-MM-DD")}
                />
              )}
              {coursingToDelete && (
                <DeletePopup
                  open={openDeleteCategory}
                  handleCloseDelete={handleCloseDeletePopup}
                  onConfirm={async () => {
                    await handleDelete(coursingToDelete.id.toString());
                  }}
                  title="Delete Schedule"
                  content={`Are you sure you want to delete "${
                    teamMap.get(coursingToDelete.empid)?.name || ""
                  }"?`}
                />
              )}
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </Drawer>
  );
};
export default DrawerPopUp;
